import { version } from '../../package.json'

export default {
  device: {
    "connected": false,
    "reconnected": false,
    "bootloaderMode": false,
    "firmwareVersion": "0.0.0",
    "bootloaderVersion": "0.0.0",
    "availableFirmware": {
      "url": "firmware/k-board-v1.1.1.syx",
      "version": "1.1.1"
    },
    "firmwareUpdateAvailable": false,
    "updatingFirmware": false
  },
  editor: {
    "beta": false,
    "status": 'disconnected',
    "networkConnection": false,
    "editorVersion": version,
    "availableEditor": {
      "version": '0.0.0'
    },
    "editorUpdateAvailable": false,
    "updatingEditor": false,
    "downloadProgress": 0,
    "deviceSyncOpen": false,
    "preferencesOpen": false,
    "midithruport": 'none'
  },
  currentPreset: {
    "midi_channel": 0,
    "mpe_active": 0,
    "mpe_member_channels": 1,
    "pressure_cc": 1,
    "tilt_cc": -1,

    "bend_range_tilt": 1,
    "bend_range_pad": 12,

    "pressure_sensitivity": 60,
    "tilt_sensitivity": 70,
    "velocity_sensitivity": 60,

    "velocity_curve": "Logarithmic",
    "pressure_disabled_return": -1,
    "tilt_disabled_return": -1,
    "on_thresh": 30
  },
  editorPreferences: {
    "showTooltips": true
  }
}
